module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "winning"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "value": _vm.shakeList,
      "to": "cash/1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'shake.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("摇一摇")])])], 2)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "box-center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("说明：")]), _vm._v("红包中奖记录在个人中心——收入栏显示明细")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129dfdbb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/winning.vue
// module id = 455
// module chunks = 0